(function () {
  'use strict';
  if (window.pdpUspBadgeLoaded) return;
  window.pdpUspBadgeLoaded = true;

  var ROOT_SELECTOR = '[data-pdp-usp-badge]';
  var READY_CLASS = 'pdp-usp-badge--ready';
  var SLIDER_CLASS = 'pdp-usp-badge--slider';
  var BOOT_INTERVAL = 100;
  var BOOT_ATTEMPTS = 100;
  var AUTOPLAY_DELAY = 3000;

  var prefersReducedMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function buildOptions(paginationEl) {
    return {
      slidesPerView: 1,
      spaceBetween: 16,
      autoHeight: false,
      speed: prefersReducedMotion ? 0 : 450,
      // Two slides still satisfy Swiper's loop minimum (slidesPerView + 1).
      loop: true,
      watchOverflow: true,
      grabCursor: true,
      // Keep rotating after a swipe; pause while hovered.
      autoplay: prefersReducedMotion
        ? false
        : {
            delay: AUTOPLAY_DELAY,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
      threshold: 5,
      touchStartPreventDefault: false,
      // Indicators are decorative progress dots, not controls.
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: false,
            bulletClass: 'pdp-usp-badge__bullet',
            bulletActiveClass: 'pdp-usp-badge__bullet--active',
            modifierClass: 'pdp-usp-badge__pagination--',
            lockClass: 'pdp-usp-badge__pagination--lock',
            renderBullet: function (index, className) {
              return '<span class="' + className + '" aria-hidden="true"></span>';
            }
          }
        : false,
      a11y: {
        enabled: true,
        containerRoleDescriptionMessage: 'carousel',
        itemRoleDescriptionMessage: 'slide'
      }
    };
  }

  /**
   * @returns {Boolean} true when the badge is settled (initialised, or does not
   *   need a slider at all), false when Swiper is not available yet.
   */
  function init(root) {
    if (!root || root.uspBadgeSwiper) return true;

    var sliderEl = root.querySelector('.pdp-usp-badge__slider');
    if (!sliderEl) return true;

    // A single USP is a static badge: no slider, no indicators.
    if (root.querySelectorAll('.pdp-usp-badge__slide').length < 2) {
      root.classList.add(READY_CLASS);
      return true;
    }

    if (typeof window.Swiper !== 'function') return false;

    var paginationEl = root.querySelector('.pdp-usp-badge__pagination');

    root.uspBadgeSwiper = new window.Swiper(sliderEl, buildOptions(paginationEl));
    root.classList.add(READY_CLASS, SLIDER_CLASS);

    return true;
  }

  function destroy(root) {
    if (root.uspBadgeSwiper) {
      root.uspBadgeSwiper.destroy(true, true);
      root.uspBadgeSwiper = null;
    }

    root.classList.remove(READY_CLASS);
    root.classList.remove(SLIDER_CLASS);
  }

  function boot(scope, attempt) {
    var roots = toArray((scope || document).querySelectorAll(ROOT_SELECTOR));
    if (!roots.length) return;

    var pending = roots.filter(function (root) {
      return !init(root);
    });

    if (!pending.length) return;

    if ((attempt || 0) >= BOOT_ATTEMPTS) return;

    window.setTimeout(function () {
      boot(scope, (attempt || 0) + 1);
    }, BOOT_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document, 0);
    });
  } else {
    boot(document, 0);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document, 0);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    toArray((event.target || document).querySelectorAll(ROOT_SELECTOR)).forEach(destroy);
  });
})();
